import { getVisitsHistory } from '@/http/visitHystoryApi';
import { getVisitsHistoryQueryKey } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetVisitsHistoryQuery = () => {
  return useQuery({
    queryKey: getVisitsHistoryQueryKey(),
    queryFn: () => getVisitsHistory(),
    select: (response) => response.data.data,
  });
};
